import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Email = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="email icon"
    className={`shrink-0 h-${size} w-${size} ${className}`}
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 10C3.85625 10 3.71604 10.0152 3.58089 10.044L24 27.6787L44.4191 10.044C44.284 10.0152 44.1437 10 44 10H4ZM2 12C2 11.7911 2.03204 11.5896 2.09147 11.4003L16.6992 24.0161L2.09184 36.6009C2.03217 36.4112 2 36.2094 2 36V12ZM3.58265 37.9564C3.71726 37.985 3.85687 38 4 38H44C44.1431 38 44.2827 37.985 44.4174 37.9564L29.7706 25.3376L24 30.3213L18.2294 25.3376L3.58265 37.9564ZM31.3008 24.0161L45.9082 36.6009C45.9678 36.4112 46 36.2094 46 36V12C46 11.7911 45.968 11.5896 45.9085 11.4003L31.3008 24.0161ZM4 8C1.79086 8 0 9.79086 0 12V36C0 38.2091 1.79086 40 4 40H44C46.2091 40 48 38.2091 48 36V12C48 9.79086 46.2091 8 44 8H4Z"
    />
  </svg>
)
